// extracted by mini-css-extract-plugin
module.exports = {"root":"BigBlockquote-module--root--6Kp0m","content":"BigBlockquote-module--content--exgDP"};